import styled from 'styled-components';

export const EachPurchase = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.s};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  h4 {
    margin-bottom: ${({ theme }) => theme.spacing.xs};
    border-bottom: 2px solid ${({ theme }) => theme.colors.grey25};
  }

  .course-name {
    font-size: 1.2rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }

  .course-list {
    margin-bottom: ${({ theme }) => theme.spacing.s};
    /* padding-left: ${({ theme }) => theme.spacing.s}; */

    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: ${({ theme }) => theme.spacing.xxs};
      font-size: 0.9rem;
      color: ${({ theme }) => theme.colors.grey6};
      /* list-style-type: disc !important; */
    }

    li span:last-child {
      font-weight: bold;
      color: ${({ theme }) => theme.colors.primaryDark};
    }
  }

  .transaction-details {
    margin-top: ${({ theme }) => theme.spacing.s};
    padding: ${({ theme }) => theme.spacing.xs};
    background-color: ${({ theme }) => theme.colors.grey15};
    border-radius: ${({ theme }) => theme.borderRadius};
    font-size: 0.9rem;

    p {
      margin-bottom: ${({ theme }) => theme.spacing.xxs};
      display: flex;
      justify-content: space-between;

      .italicSpan {
        font-style: italic;
        color: ${({ theme }) => theme.colors.grey6};
      }
    }
  }

  .purchaser-info,
  .purchased-for {
    margin-top: ${({ theme }) => theme.spacing.s};
    font-size: 0.9rem;

    p {
      margin-bottom: ${({ theme }) => theme.spacing.xxs};

      .italicSpan {
        font-style: italic;
        color: ${({ theme }) => theme.colors.grey6};
      }
    }
  }
`;
